<template>
    <div class="portfolio_edit_box">
        <div class="item_create_wrap">
            <ul class="radio_wrap">
                <li class="">
                    <h3 class="sub_title_m regular">{{ $t('portfolio_setting') }}</h3>
                    <div class="edit_textarea">
<!--                        <el-input type="textarea" id="portfolio" v-model="portfolio"
                                  :placeholder="$t('input_inform')"></el-input>-->
                        <quill-editor
                            ref="contentEditor"
                            v-model="portfolio"
                            :options="editorOption"
                        />
                        <div class="val_cap" v-if="validation.hasError('content')">
                            {{ validation.firstError('content') }}
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <div class="btn_wrap">
            <div class="two_btn temp_btn" @click="$router.back()">{{$t('cancel')}}</div>
            <div class="two_btn save_btn" @click="save()">{{$t('save')}}</div>
        </div>

    </div>
</template>

<script>
import {mapState, mapGetters} from "vuex";
import util from "@/mixins/util";
import EventBus from "@/utils/event-bus";
import quillEditorMixins from "@/mixins/quillEditorMixins";
import memberValidator from "@/mixins/validators/memberValidator";

export default {
    name: "MemberWritePortfolioLayout",
    mixins: [quillEditorMixins, memberValidator],
    components: {},
    inject: ['memberSetData'],
    provide() {
        return {}
    },
    props: {
        memberData: {default: () => {}},
    },
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.initSetData();
        EventBus.$on('MemberWritePortfolioLayoutForceUpdate', this.layoutForceUpdate);
    },
    beforeDestroy() {
        EventBus.$off('MemberWritePortfolioLayoutForceUpdate');
    },
    destroyed() {
    },
    computed: {
        ...mapState({
            UserInfo: state => state.userInfo.UserInfo,
        })
    },
    methods: {
        parentChange(type, value) {
            this.memberSetData(type, value);
        },

        initSetData() {
            if(util.isEmpty(this.memberData)) {
                return false;
            }
            this.portfolio = this.memberData.mb_portfolio
            this.portfolio = util.htmlDecode(this.portfolio);
            this.parentChange('portfolio', this.portfolio);
        },
        save() {
            EventBus.$emit('updateMember')
        },
    },
    watch: {
        'portfolio': {
            deep: true,
            handler: function (val, oldVal) {
                this.parentChange('portfolio', this.portfolio)
            },
        }
    },
}
</script>

<style scoped>

</style>

